// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: ''
};

// ----------------------------------------------------------------------

export const paths = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  // AUTH
  auth: {
    amplify: {
      login: `${ROOTS.AUTH}/login`,
      verify: `${ROOTS.AUTH}/verify`,
      register: `${ROOTS.AUTH}/register`,
      newPassword: `${ROOTS.AUTH}/new-password`,
      forgotPassword: `${ROOTS.AUTH}/forgot-password`,
      firstAccess: `${ROOTS.AUTH}/first-access`
    }
  },
  // DASHBOARD
  dashboard: {
    auto: `${ROOTS.DASHBOARD}/auto`,
    root: `${ROOTS.DASHBOARD}/`,
    companies: `${ROOTS.DASHBOARD}/companies`,
    companyDetail: (id) => `${ROOTS.DASHBOARD}/companies/${id}`,
    companyOnboarding: (id) => `${ROOTS.DASHBOARD}/companies/${id}/onboarding`,
    onboardingConfiguration: `${ROOTS.DASHBOARD}/config/onboarding`,
    studioTemplates: `${ROOTS.DASHBOARD}/config/studio-templates`,
    newCompany: `${ROOTS.DASHBOARD}/companies/new`,
    hiring: `${ROOTS.DASHBOARD}/hiring`,
    terminations: `${ROOTS.DASHBOARD}/terminations`,
    letters: `${ROOTS.DASHBOARD}/letters`,
    helpDesk: `${ROOTS.DASHBOARD}/help-desk`,
    news: `${ROOTS.DASHBOARD}/news`,
    newNews: `${ROOTS.DASHBOARD}/news/new`,
    popupNotices: `${ROOTS.DASHBOARD}/popup-notices`,
    externalLinks: `${ROOTS.DASHBOARD}/external-links`,
    employeeExternalLinks: `${ROOTS.DASHBOARD}/employee-external-links`,
    faqElearning: `${ROOTS.DASHBOARD}/faq-e-learning`,
    uploadDocuments: `${ROOTS.DASHBOARD}/upload-documents`,
    uploadPayslips: `${ROOTS.DASHBOARD}/upload-payslips`,
    account: `${ROOTS.DASHBOARD}/account`,
    config: `${ROOTS.DASHBOARD}/config`,
    import: `${ROOTS.DASHBOARD}/import`,
    consultants: `${ROOTS.DASHBOARD}/consultants`,
    managers: `${ROOTS.DASHBOARD}/managers`,
    clockings: `${ROOTS.DASHBOARD}/clockings`,
    integrations: {
      bpoint: `${ROOTS.DASHBOARD}/integrazioni/bpoint`,
      bpointTab: (tab) => `${ROOTS.DASHBOARD}/integrazioni/bpoint/${tab}`,
      pagheweb: `${ROOTS.DASHBOARD}/integrazioni/pagheweb`,
      paghewebTab: (tab) => `${ROOTS.DASHBOARD}/integrazioni/pagheweb/${tab}`,
      zucchettiExport: `${ROOTS.DASHBOARD}/integrazioni/zucchetti-export`,
      zucchettiPreview: `${ROOTS.DASHBOARD}/integrazioni/zucchetti-anteprima`,
      apiKeys: `${ROOTS.DASHBOARD}/integrazioni/api-keys`,
      clockingConnector: `${ROOTS.DASHBOARD}/integrazioni/connettore-timbrature`,
    },
  },
  // COMPANY
  company: {
    employees: `${ROOTS.DASHBOARD}/company/employees`,
    newEmployee: `${ROOTS.DASHBOARD}/company/employees/new`,
    timesheet: `${ROOTS.DASHBOARD}/company/timesheet`,
    calendar: `${ROOTS.DASHBOARD}/company/timetable`,
    payTransparency: `${ROOTS.DASHBOARD}/company/pay-transparency`,
    payTransparencyDetail: (id) => `${ROOTS.DASHBOARD}/company/pay-transparency/${id}`,
    documents: `${ROOTS.DASHBOARD}/company/documents`,
    documentsSignatures: `${ROOTS.DASHBOARD}/company/documents-signatures`,
    requests: `${ROOTS.DASHBOARD}/company/requests`,
    holidayPlan: `${ROOTS.DASHBOARD}/company/holiday-plan`,
    stats: `${ROOTS.DASHBOARD}/company/stats`,
    employeesPayrollData: `${ROOTS.DASHBOARD}/company/report/employee-payroll-data`,
    employeesDocuments: `${ROOTS.DASHBOARD}/company/report/employee-documents`,
    notices: `${ROOTS.DASHBOARD}/company/comunicazioni`,
    payrollData: `${ROOTS.DASHBOARD}/company/payroll-data`,
    expenseReports: `${ROOTS.DASHBOARD}/company/note-spese`,
    clockingPlaces: `${ROOTS.DASHBOARD}/company/clocking-places`,
    account: `${ROOTS.DASHBOARD}/company/account`,
    config: {
      root: `${ROOTS.DASHBOARD}/config`,
      timesheet: `${ROOTS.DASHBOARD}/config/timesheet`,
      holidayPlan: `${ROOTS.DASHBOARD}/config/holiday-plan`,
      projects: `${ROOTS.DASHBOARD}/config/projects`,
      expenseReports: `${ROOTS.DASHBOARD}/config/expense-reports`,
      clockingPlaces: `${ROOTS.DASHBOARD}/config/clocking-places`,
      supervisors: `${ROOTS.DASHBOARD}/config/supervisors`,
      documentTemplates: `${ROOTS.DASHBOARD}/config/document-templates`,
      customFields: `${ROOTS.DASHBOARD}/config/custom-fields`,
      statusOptions: `${ROOTS.DASHBOARD}/config/status-options`,
      areas: `${ROOTS.DASHBOARD}/config/areas`,
    },
  }
};
